// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/DrawerItem.scss
// module id = ./src/styles/DrawerItem.scss
// module chunks = 0